import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import ArticleTen from '../components/ArticleTen'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleTen)
